// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__3zWBk","loaderBox":"loader_loaderBox__2L7Sq","loaderRound":"loader_loaderRound__36PXW"};